import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CatalogContentAndSearchResolver, SearchResult } from 'src/core-lib/navigation/services/content.resolver';
import { MediaModule } from 'src/layout/media/media.module';
import { UrlUtil } from 'src/utils/url.util';
import { CatalogFacetsComponent } from '../catalog-facets/catalog-facets.component';
import { CatalogSortComponent } from '../catalog-sort/catalog-sort.component';

@Component({
    selector: 'app-catalog-form',
    standalone: true,
    imports: [CatalogFacetsComponent, CatalogSortComponent, TranslateModule, CommonModule, MediaModule],
    templateUrl: './catalog-form.component.html',
    styleUrl: './catalog-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogFormComponent {
    @Input() result: SearchResult;
    constructor(
        private _productSearchService: CatalogContentAndSearchResolver,
    ) {}

    updateUrl() {
        this._productSearchService.updateUrlByForm(new FormData(document.forms['catalogForm']));
    }

    resetFacetsInUrl() {
        var data = new FormData(window['catalogForm']);
        for (const [key, value] of data.entries())
            if (key.startsWith(UrlUtil.FACET_PREFIX) || value.toString().length < 1)
                data.delete(key);
        this._productSearchService.updateUrlByForm(data);
    }
    deselectFacet(id: string) {
        (document.getElementById(id) as HTMLInputElement).checked = false;

        this._productSearchService.updateUrlByForm(new FormData(window['catalogForm']));
    }
}
